module.exports = __webpack_public_path__ + "static/media/IMG_3491_sm.1a7e1e6b.jpg";